import React from 'react';
import { motion } from 'framer-motion';
import { ScanLineIcon, SearchIcon, UsersIcon, CalendarCheckIcon, ArrowRightIcon, DownloadIcon } from 'lucide-react';
export function Services() {
  const services = [{
    icon: ScanLineIcon,
    title: 'Live Scan Fingerprinting',
    description: 'State-of-the-art electronic fingerprint capture. This is the exclusive method accepted by the State of Maryland for official background checks.',
    highlight: true
  }, {
    icon: UsersIcon,
    title: 'Mobile / Group Fingerprinting',
    description: 'We bring our portable Live Scan equipment to your office or facility for groups of 5 or more. Fast, efficient processing on-site.',
    highlight: true
  }, {
    icon: SearchIcon,
    title: 'Background Checks',
    description: 'Comprehensive criminal history background checks through CJIS and the FBI. Required for employment, licensing, and certification.',
    highlight: false
  }, {
    icon: CalendarCheckIcon,
    title: 'Appointment Scheduling',
    description: 'All services are by appointment only. Book online in minutes and choose the date and time that works best for you or your organization.',
    highlight: false
  }];
  return <section id="services" className="py-12 lg:py-20 bg-slate-50 border-b border-slate-200/60" aria-labelledby="services-heading" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="text-center mb-16 lg:mb-20" data-id="element-228">
          <h2 id="services-heading" className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight" data-id="element-229">
            Services We Offer
          </h2>
          <div className="w-16 h-1.5 bg-[#4AA6CF] mx-auto rounded-full mb-8" aria-hidden="true" data-id="element-230"></div>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-231">
            Professional Live Scan fingerprinting and background checks — by
            appointment only.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 lg:mb-20" data-id="element-232">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white border rounded-2xl p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 flex flex-col h-full group ${service.highlight ? 'border-[#4AA6CF]/30 ring-1 ring-[#4AA6CF]/5' : 'border-slate-200'} ${index < 2 ? 'lg:col-span-6' : 'lg:col-span-6'}`} data-id="element-233">
              <div className="flex items-start gap-4 mb-6" data-id="element-234">
                <div className={`p-4 rounded-xl transition-all duration-500 shadow-inner border border-slate-100 group-hover:shadow-2xl group-hover:shadow-slate-200 ${service.highlight ? 'bg-[#4AA6CF]/10 text-[#4AA6CF] group-hover:bg-[#4AA6CF] group-hover:text-white' : 'bg-slate-50 text-[#4AA6CF] group-hover:bg-slate-900 group-hover:text-white'}`} data-id="element-235">
                  <service.icon className="h-8 w-8" aria-hidden="true" data-id="element-236" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1E1F55] mb-4 leading-tight" data-id="element-237">
                {service.title}
              </h3>
              <p className="text-slate-600 text-base leading-relaxed mb-8 flex-grow" data-id="element-238">
                {service.description}
              </p>
              <a href="#/booking" className="inline-flex items-center text-[#2B7A9E] text-sm font-semibold hover:text-[#1E1F55] transition-colors mt-auto" data-id="element-239">
                Book Appointment
                <ArrowRightIcon className="ml-2 h-4 w-4" aria-hidden="true" data-id="element-240" />
              </a>
            </motion.div>)}
        </div>

        <div className="flex justify-center mt-12 lg:mt-20" data-id="element-241">
          <motion.a href="https://health.maryland.gov/bswe/Documents/OnlineLicApplications/Livescan%20Pre-RegApp.pdf" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center gap-3 px-10 py-5 border-2 border-slate-900 text-slate-900 rounded-full font-extrabold text-lg hover:bg-slate-900 hover:text-white transition-all w-full sm:w-auto shadow-sm hover:shadow-xl" aria-label="Download LiveScan Pre-Registration Form (PDF)" data-id="element-242">
            <DownloadIcon className="h-5 w-5" aria-hidden="true" data-id="element-243" />
            Download LiveScan Pre-Registration Form
          </motion.a>
        </div>
      </div>
    </section>;
}